import React, { useEffect, useState } from 'react'
import './admin.css'
import AdminNavbar from '../../admin-components/admin-nav/AdminNavbar'
import AdminBottomNav from '../../admin-components/adminbottomnav/AdminBottomNav'
import Counters from '../../admin-components/counters/Counters'
import Posts from '../../components/posts/Posts'
// import { Context } from "../../context/Context";
import axios from 'axios'
import { useLocation } from 'react-router'

function Admin() {
    const [posts, setPosts] = useState([]);
    const [allPosts, setAllPosts] = useState([]);
    const [cats, setCats] = useState([]);
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const {search} = useLocation();
    // const {user} = useContext(Context);  

    const api_uri = "https://mentorxfa.herokuapp.com/api/posts";   
    const api_uri_cat = "https://mentorxfa.herokuapp.com/api/categories";   
    const api_uri_user = "https://mentorxfa.herokuapp.com/api/users";   

    useEffect(() => {
        const fetchPosts = async() => {
            const res = await axios.get(api_uri + search);
            const res_cats = await axios.get(api_uri_cat);
            const res_users = await axios.get(api_uri_user);
            setAllPosts(res.data)
            setPosts(res.data.reverse().sort((a, b) => a.createdAt > b.createdAt ? -1 : 1).slice(0,5));
            setCats(res_cats.data)
            setUsers(res_users.data)
            setIsLoading(false)  
        }
        fetchPosts()   
        return () => {
            setPosts([]);
            setIsLoading(false)
            setSearchTerm("")
          };
    }, [search]);
    return (
        <>
        <AdminNavbar/>
        <div className="admin">
            <Counters posts={allPosts.length} cats={cats.length} users= {users.length}/>
            <div className="recent-posts">
                <div className="recent-posts-title">Recent Posts</div>
                <Posts loading={isLoading} posts={posts} searchTerm={searchTerm} />
            </div>
        </div>
        <AdminBottomNav/>
        </>
    )
}

export default Admin
